<template>
  <v-dialog
    v-model="innerVal"
    max-width="800"
  >
    <DialogCardLayout
      :logo="logo"
      @close="innerVal = false"
      title="Terms and Conditions"
    >
      <ConditionItem
        v-for="(item,key) in items"
        :key="key"
        :number="key+1"
        :item="item"
        :class="(key+1)!==items.length?'mb-3':''"
      ></ConditionItem>
    </DialogCardLayout>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ResellerConditionDialog',

    components: {
      ConditionItem: () => import('./ConditionItem.vue'),
      DialogCardLayout: () => import('./DialogCardLayout.vue')
    },

    props: {
      value: { type:Boolean, default:false },
      items: {
        type: Array,
        default: () => {
          return [];
        }
      },
      logo: {
        type: String,
        default: null
      }
    },

    data() {
      return {
        innerVal: this.value,
        // items: [
        //   'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        //   'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        //   'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        //   'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        //   'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        //   'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        //   'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        //   'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        //   'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
        // ]
      }
    },

    watch: {
      value(val) {
        this.innerVal = val
      },
      innerVal(val) {
        this.$emit('input', val)
      }
    },

    methods: {
      //
    }
  }
</script>

<style lang="scss" scoped>

</style>